import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { ERROR_MAP } from "./SSOPage";

export default function SSOErrorPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const reason = params.get("reason") || "invalid_token";
  const msg = ERROR_MAP[reason] || "We couldn’t complete that handoff.";

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center fade-in-up">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#F5E6D3] text-[#A86B4A] flex items-center justify-center">
          <AlertCircle size={30} strokeWidth={1.8} />
        </div>
        <h1 className="font-display text-3xl text-[#2E2E2E] mb-2">Something went sideways</h1>
        <p className="text-[#6B6B6B] leading-relaxed mb-8">{msg}</p>

        <div className="space-y-3">
          <a
            href="https://ineedaproverb.com"
            data-testid="sso-back-to-proverb"
            className="block w-full bg-[#4F6F52] hover:bg-[#3F5A42] text-white rounded-full py-3.5 font-medium transition shadow-[0_4px_14px_rgba(79,111,82,0.18)]"
          >
            Return to I Need a Proverb
          </a>
          <button
            onClick={() => navigate("/login")}
            data-testid="sso-login"
            className="block w-full bg-white border border-[#DCE5DB] hover:bg-[#EEF3EC] text-[#2E2E2E] rounded-full py-3.5 font-medium transition"
          >
            Log Into LifeGuide
          </button>
          <a
            href="https://ineedaproverb.com"
            data-testid="sso-new-handoff"
            className="block w-full text-sm text-[#4F6F52] hover:underline pt-2"
          >
            Request a New Handoff
          </a>
        </div>
      </div>
    </div>
  );
}
